/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-bind */
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Empty, Modal, Tabs } from 'antd';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { BoxForm, BoxInput, ButtonContainer, Container } from './styles';
import { PageTitle } from '../../components/PageTitle';
import { api } from '../../services/api';
import { Loading } from '../../components/Loading';
import {
  Testimonial,
  TestimonialAvatar,
  TestimonialContainer,
} from '../ProductUpdate/styles';
import { TestimonialSearch } from '../TechnicalTeam/styles';
import styles from './Depoimentos.module.css';

export function CategoriesUpdate() {
  const [initialValues, setInitialValues] = useState({
    name: '',
    code: '',
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const { product_categorie_id } = useParams();
  const [isModalTechnicalTeamOpen, setModalTechnicalTeamOpen] = useState(false);
  const [technicalTeamIdSeleted, setTechnicalTeamIdSeleted] = useState([]);
  const [allTechnicalTeam, setAllTechnicalTeam] = useState([]);
  const [technicalTeam, setTechnicalTeam] = useState([]);
  const [isSortLoading, setIsSortLoading] = useState(false);

  async function loadProductCategorie() {
    try {
      const response = await api.get(
        `/products/categories/${product_categorie_id}`,
      );

      setInitialValues(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao carregar dados da categoria');
    }
  }

  async function updateProductCategorie(values) {
    setButtonLoading(true);
    try {
      const { name } = values;

      await api.put(`/products/categories/${product_categorie_id}`, {
        name,
      });

      toast.success('Categoria atualizada com sucesso');
      setButtonLoading(false);
      navigate(-1);
    } catch (err) {
      toast.error('Erro ao atualizar categoria');
      setButtonLoading(false);
    }
  }

  useEffect(() => {
    loadProductCategorie();
  }, []);

  function handleChangeTechnicalTeamProduct(checkedValues) {
    setTechnicalTeamIdSeleted(checkedValues);
  }

  async function loadTechnicalTeam() {
    try {
      const response = await api.get(
        `/technical-team/show-product-category/${product_categorie_id}`,
      );
      console.log('response', response.data);

      setTechnicalTeam(response.data);
      setTechnicalTeamIdSeleted(response.data.map((t) => t.technicalTeamId));
    } catch (error) {
      toast.error('Erro ao buscar corpo técnico');
    }
  }

  async function addTechnicalTeamToProduct() {
    try {
      await api.post('/technical-team/add-to-product-category', {
        product_category_id: product_categorie_id,
        technical_team_ids: technicalTeamIdSeleted,
      });

      loadTechnicalTeam();
      setModalTechnicalTeamOpen(false);
      toast.success('Corpo técnico atualizado com sucesso');
    } catch (error) {
      toast.error('Error ao atualizar Corpo técnico');
    }
  }

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name) {
    const nameParts = name.split(' ');

    if (nameParts.length === 1) {
      return `${nameParts[0][0]}${nameParts[0][0]}`.toUpperCase();
    }

    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
  }

  async function loadAllTechnicalTeam() {
    try {
      const response = await api.get('/technical-team/all');
      setAllTechnicalTeam(response.data.technical_team);
    } catch (error) {
      toast.error('Erro ao buscar corpo técnico');
    }
  }

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(technicalTeam);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setTechnicalTeam(items);
  }

  async function sortTestimonial() {
    try {
      setIsSortLoading(true);
      await api.post('/technical-team/sort-product-category', {
        technical_team: technicalTeam,
      });
      setIsSortLoading(false);
      toast.success('Corpo técnico ordenado com sucesso');
    } catch (error) {
      console.log(error);
      setIsSortLoading(false);

      toast.error('Erro ao ordenar corpo técnico');
    }
  }

  const formContent = (
    <BoxForm>
      <Formik initialValues={initialValues} onSubmit={updateProductCategorie}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <BoxInput>
              <label htmlFor="code">Código</label>
              <Field
                id="code"
                type="text"
                name="code"
                placeholder="Nome"
                disabled
              />
            </BoxInput>

            <BoxInput>
              <label htmlFor="name">Nome</label>
              <Field id="name" type="text" name="name" placeholder="Nome" />
            </BoxInput>

            <ButtonContainer>
              <Button
                type="primary"
                htmlType="submit"
                size="middle"
                loading={buttonLoading}
              >
                Atualizar categoria
              </Button>
            </ButtonContainer>
          </form>
        )}
      </Formik>
    </BoxForm>
  );

  const technicalTeamComponent = (
    <>
      <Button onClick={() => setModalTechnicalTeamOpen(true)}>
        Atualizar corpo técnico
      </Button>

      <Button loading={isSortLoading} style={{ marginLeft: 20 }} onClick={sortTestimonial}>
        Salvar ordenação
      </Button>

      <TestimonialContainer>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="characters">
            {(provided) => (
              <div
                className={styles.moduleList}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {!!technicalTeam.length &&
                  technicalTeam.map((productTestimonial, index) => (
                    <Draggable
                      key={productTestimonial.technical_team.id}
                      draggableId={productTestimonial.technical_team.id}
                      index={index}
                    >
                      {(providedDrag) => (
                        <TestimonialSearch
                          ref={providedDrag.innerRef}
                          {...providedDrag.draggableProps}
                          {...providedDrag.dragHandleProps}
                          className={styles.moduleListItem}
                        >
                          <div>
                            {productTestimonial.technical_team.photo_url ? (
                              <img
                                src={
                                  productTestimonial.technical_team.photo_url
                                }
                                style={{ width: 50, height: 50 }}
                                alt=""
                              />
                            ) : (
                              <TestimonialAvatar
                                style={{
                                  background: stringToColor(
                                    productTestimonial.technical_team.name ||
                                    '',
                                  ),
                                }}
                              >
                                {stringAvatar(
                                  productTestimonial.technical_team.name || '',
                                )}
                              </TestimonialAvatar>
                            )}

                            <div className="info">
                              <span>
                                {productTestimonial.technical_team.name}
                              </span>
                              <p>{productTestimonial.technical_team.text}</p>
                            </div>
                          </div>
                        </TestimonialSearch>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        {!technicalTeam.length && (
          <Empty
            style={{ padding: '40px 0 ' }}
            description="Nenhum corpo técnico nessa categoria"
          />
        )}
      </TestimonialContainer>
    </>
  );

  const tabsContent = [
    {
      label: 'Editar categoria',
      key: 1,
      children: formContent,
    },
    {
      label: 'Corpo técnico',
      key: 2,
      children: technicalTeamComponent,
    },
  ];

  useEffect(() => {
    loadAllTechnicalTeam();
    loadTechnicalTeam();
  }, []);

  console.log('technicalTeam', technicalTeam);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="/categorias">
          <NavLink to="/categorias">Categorias</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Criação</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle title="Cadastro de categoria" />

      {!loading && (
        <Tabs
          defaultActiveKey="1"
          centered
          items={tabsContent.map((content) => content)}
        />
      )}

      {loading && <Loading />}

      <Modal
        title="Corpo técnico"
        open={isModalTechnicalTeamOpen}
        footer={null}
        onCancel={() => setModalTechnicalTeamOpen(false)}
        width={1200}
      >
        <>
          <TestimonialContainer>
            <Checkbox.Group
              style={{
                width: '100%',
              }}
              onChange={handleChangeTechnicalTeamProduct}
              defaultValue={technicalTeamIdSeleted}
            >
              {allTechnicalTeam.map((testimonial) => (
                <Testimonial>
                  <Checkbox value={testimonial.id} />

                  <div>
                    {testimonial.photo_url ? (
                      <img
                        // className={styles.avatar}
                        src={testimonial.photo_url}
                        style={{ width: 50, height: 50 }}
                        alt=""
                      />
                    ) : (
                      <TestimonialAvatar
                        style={{
                          background: stringToColor(testimonial.name),
                        }}
                      >
                        {stringAvatar(testimonial.name)}
                      </TestimonialAvatar>
                    )}

                    <div className="info">
                      <span>{testimonial.name}</span>
                      <p>{testimonial.text}</p>
                    </div>
                  </div>
                </Testimonial>
              ))}
            </Checkbox.Group>
          </TestimonialContainer>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Button onClick={addTechnicalTeamToProduct} type="primary">
              Salvar
            </Button>
          </div>
        </>
      </Modal>
    </Container>
  );
}
